var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import { Button, Dimmer, Header, Label, Loader, Message, Modal, Popup, Table } from "semantic-ui-react";
import { API_SVC_BASE_URL } from "../Config";
import { deleteWithAuthn, getWithAuthn, postJsonWithAuthn, postWithAuthn } from "../RequestHelpers";
/**
 * Review view over the bulk probe design sheet. Shows the same work list as the CSV, with each
 * row's catalog-match status, and lets the probe team resolve a commented catalog order in one
 * click — assigning the family's existing CAT design directly instead of editing the sheet's
 * Catalog Design flag and taking the row through Exon. Assigned kits drop off the sheet, so the
 * CSV downloaded from here only carries what still needs a designer.
 */
var ProbeDesignReviewModal = /** @class */ (function (_super) {
    __extends(ProbeDesignReviewModal, _super);
    function ProbeDesignReviewModal(props) {
        var _this = _super.call(this, props) || this;
        _this.dispatchFileInputRef = React.createRef();
        _this.onMarkDispatched = function (event) {
            var _a;
            var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
            event.target.value = '';
            if (!file)
                return;
            _this.setState({ markingDispatched: true, error: undefined });
            var formData = new FormData();
            formData.append('file', file);
            postWithAuthn('/probe-design/mark-dispatched', formData)
                .then(function (resp) { return __awaiter(_this, void 0, void 0, function () {
                var body;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, resp.json().catch(function () { return undefined; })];
                        case 1:
                            body = _a.sent();
                            if (resp.status === 200) {
                                this.setState(function (s) {
                                    var _a, _b;
                                    return (__assign(__assign({}, s), { markingDispatched: false, results: s.results
                                            .concat((_a = body === null || body === void 0 ? void 0 : body.results) !== null && _a !== void 0 ? _a : [])
                                            .concat(((_b = body === null || body === void 0 ? void 0 : body.errors) !== null && _b !== void 0 ? _b : []).map(function (e) { return "\u26A0 " + e; })) }));
                                });
                                this.load();
                            }
                            else {
                                this.setState({ markingDispatched: false, error: typeof body === 'string' ? body : 'The sheet could not be processed.' });
                            }
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function () {
                _this.setState({ markingDispatched: false, error: 'The sheet could not be processed.' });
            });
        };
        _this.sitesFileInputRef = React.createRef();
        _this.pickBindingSitesFile = function (row) {
            _this.setState({ sitesUploadRow: rowKey(row), error: undefined }, function () { var _a; return (_a = _this.sitesFileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); });
        };
        /**
         * Backfills a siteless assigned variant from the designer's Compare workbook, through the same
         * per-variant binding-sites endpoint the catalog page uses. On success the kit holds a designed
         * variant and drops off the pending list, so the whole review reloads.
         */
        _this.onBindingSitesFile = function (event) {
            var _a;
            var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
            event.target.value = '';
            var key = _this.state.sitesUploadRow;
            var row = _this.state.rows.find(function (r) { return rowKey(r) === key; });
            if (!file || !row || !row.sitelessDesign) {
                _this.setState({ sitesUploadRow: undefined });
                return;
            }
            var design = row.sitelessDesign;
            var label = "Order " + row.orderNumber + " Kit #" + row.kitNumber;
            var formData = new FormData();
            formData.append('attachment', file);
            postWithAuthn("/admin/catalog/rna/organisms/id/" + encodeURIComponent(design.organismId.toString()) +
                ("/probe-set-families/id/" + encodeURIComponent(design.probeSetFamilyId.toString())) +
                ("/variants/id/" + encodeURIComponent(design.variantId.toString()) + "/binding-sites"), formData)
                .then(function (resp) { return __awaiter(_this, void 0, void 0, function () {
                var body, msgs;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (resp.status === 200) {
                                this.setState(function (s) { return (__assign(__assign({}, s), { sitesUploadRow: undefined, results: s.results.concat(label + ": binding sites added to " + design.designNumber + " \u2014 kit leaves the design sheet") })); });
                                this.load();
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, resp.json().catch(function () { return undefined; })];
                        case 1:
                            body = _b.sent();
                            msgs = ((_a = body === null || body === void 0 ? void 0 : body.errors) !== null && _a !== void 0 ? _a : []).map(function (e) { return e.msg; });
                            this.setState({
                                sitesUploadRow: undefined,
                                error: label + ": " + (msgs.length > 0 ? msgs.join(' · ') : "binding sites could not be added (" + resp.status + ")")
                            });
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function () {
                _this.setState({ sitesUploadRow: undefined, error: label + ": binding sites could not be added." });
            });
        };
        _this.returnToSheet = function (row, key) {
            _this.setState(function (s) { return (__assign(__assign({}, s), { assigning: new Set(s.assigning).add(key) })); });
            postJsonWithAuthn('/probe-design/clear-dispatch', JSON.stringify({
                orderNumber: row.orderNumber,
                kitNumber: row.kitNumber,
                channel: row.channel
            }))
                .then(function (resp) { return __awaiter(_this, void 0, void 0, function () {
                var body;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, resp.json().catch(function () { return undefined; })];
                        case 1:
                            body = _a.sent();
                            this.setState(function (s) {
                                var _a, _b;
                                var assigning = new Set(s.assigning);
                                assigning.delete(key);
                                return resp.status === 200
                                    ? __assign(__assign({}, s), { assigning: assigning, results: s.results.concat("Order " + row.orderNumber + " " + ((_a = body === null || body === void 0 ? void 0 : body.message) !== null && _a !== void 0 ? _a : 'probe returned to the design sheet')) }) : __assign(__assign({}, s), { assigning: assigning, error: "Order " + row.orderNumber + " " + ((_b = body === null || body === void 0 ? void 0 : body.message) !== null && _b !== void 0 ? _b : "could not be returned (" + resp.status + ")") });
                            });
                            if (resp.status === 200)
                                this.load();
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function () {
                _this.setState(function (s) {
                    var assigning = new Set(s.assigning);
                    assigning.delete(key);
                    return __assign(__assign({}, s), { assigning: assigning, error: "Order " + row.orderNumber + " Kit #" + row.kitNumber + ": could not be returned to the sheet." });
                });
            });
        };
        _this.removeDesign = function (row, key) {
            _this.setState(function (s) { return (__assign(__assign({}, s), { assigning: new Set(s.assigning).add(key) })); });
            deleteWithAuthn("/admin/orders/id/" + encodeURIComponent(row.orderNumber) +
                ("/items/id/" + encodeURIComponent(row.itemId) + "/variant-assignment") +
                ("?productType=" + encodeURIComponent(row.productType) + "&channel=" + encodeURIComponent(row.channel)))
                .then(function (resp) {
                if (resp.status === 200) {
                    // The kit is now undesigned, so it belongs in the pending list and the CSV
                    // count — reload everything rather than patching state.
                    _this.setState(function (s) {
                        var assigning = new Set(s.assigning);
                        assigning.delete(key);
                        return __assign(__assign({}, s), { assigning: assigning, results: s.results.concat("Order " + row.orderNumber + " Kit #" + row.kitNumber + ": design " + row.designNumber + " removed \u2014 kit rejoins the design sheet") });
                    });
                    _this.load();
                }
                else {
                    _this.setState(function (s) {
                        var assigning = new Set(s.assigning);
                        assigning.delete(key);
                        return __assign(__assign({}, s), { assigning: assigning, error: "Order " + row.orderNumber + " Kit #" + row.kitNumber + ": design could not be removed (" + resp.status + ")." });
                    });
                }
            })
                .catch(function () {
                _this.setState(function (s) {
                    var assigning = new Set(s.assigning);
                    assigning.delete(key);
                    return __assign(__assign({}, s), { assigning: assigning, error: "Order " + row.orderNumber + " Kit #" + row.kitNumber + ": design could not be removed." });
                });
            });
        };
        _this.open = function () {
            _this.setState({ open: true, results: [] });
            _this.load();
        };
        _this.close = function () {
            _this.setState({ open: false });
        };
        _this.load = function () {
            _this.setState({ loading: true, error: undefined });
            getWithAuthn('/probe-design/design-review')
                .then(function (resp) {
                if (resp.status !== 200) {
                    throw new Error("Design review failed to load (" + resp.status + ")");
                }
                return resp.json();
            })
                .then(function (body) {
                _this.setState({ loading: false, rows: body.rows, fyiRows: body.fyiRows, sentRows: body.sentRows });
            })
                .catch(function () {
                _this.setState({ loading: false, error: 'Design review could not be loaded.' });
            });
        };
        _this.assign = function (row) {
            var key = rowKey(row);
            _this.setState(function (s) { return ({ assigning: new Set(s.assigning).add(key) }); });
            postJsonWithAuthn('/probe-design/assign-catalog-design', JSON.stringify({
                orderNumber: row.orderNumber,
                kitNumber: row.kitNumber,
                channel: row.channel
            }))
                .then(function (resp) { return __awaiter(_this, void 0, void 0, function () {
                var body, message;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, resp.json().catch(function () { return undefined; })];
                        case 1:
                            body = _b.sent();
                            message = (_a = body === null || body === void 0 ? void 0 : body.message) !== null && _a !== void 0 ? _a : "Kit #" + row.kitNumber + ": unexpected response (" + resp.status + ")";
                            this.setState(function (s) {
                                var assigning = new Set(s.assigning);
                                assigning.delete(key);
                                return resp.status === 200
                                    ? __assign(__assign({}, s), { assigning: assigning, rows: s.rows.filter(function (r) { return rowKey(r) !== key; }), results: s.results.concat("Order " + row.orderNumber + " " + message), error: undefined }) : __assign(__assign({}, s), { assigning: assigning, error: "Order " + row.orderNumber + " " + message });
                            });
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function () {
                _this.setState(function (s) {
                    var assigning = new Set(s.assigning);
                    assigning.delete(key);
                    return __assign(__assign({}, s), { assigning: assigning, error: "Order " + row.orderNumber + " Kit #" + row.kitNumber + ": assignment failed." });
                });
            });
        };
        _this.state = {
            open: false,
            loading: false,
            error: undefined,
            rows: [],
            fyiRows: [],
            sentRows: [],
            assigning: new Set(),
            results: [],
            markingDispatched: false,
            sitesUploadRow: undefined
        };
        return _this;
    }
    ProbeDesignReviewModal.prototype.render = function () {
        var _this = this;
        return React.createElement(Modal, { closeIcon: true, size: 'fullscreen', open: this.state.open, onClose: this.close, trigger: React.createElement(Button, { icon: 'clipboard list', label: 'Bulk Probe Design', labelPosition: 'left', onClick: this.open }) },
            React.createElement(Modal.Header, null, "Probe Design Review"),
            React.createElement(Modal.Content, { scrolling: true },
                React.createElement(Dimmer.Dimmable, { as: 'div' },
                    React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                        React.createElement(Loader, null)),
                    this.state.error &&
                        React.createElement(Message, { negative: true }, this.state.error),
                    this.state.results.length > 0 &&
                        React.createElement(Message, { positive: true },
                            React.createElement(Message.List, null, this.state.results.map(function (r, i) { return React.createElement(Message.Item, { key: i }, r); }))),
                    !this.state.loading && !this.state.error && this.state.rows.length === 0
                        ? React.createElement(Message, null, "No kits are waiting on a probe design.")
                        : this.renderTable(),
                    this.state.sentRows.length > 0 && this.renderSentSection(),
                    this.state.fyiRows.length > 0 && this.renderFyiSection())),
            React.createElement(Modal.Actions, null,
                React.createElement(Button, { icon: 'refresh', content: 'Refresh', onClick: this.load, disabled: this.state.loading }),
                React.createElement("input", { type: "file", accept: ".csv", ref: this.dispatchFileInputRef, style: { display: 'none' }, onChange: this.onMarkDispatched }),
                React.createElement("input", { type: "file", accept: ".xlsx", ref: this.sitesFileInputRef, style: { display: 'none' }, onChange: this.onBindingSitesFile }),
                React.createElement(Popup, { content: 'Upload the exact sheet you submitted to Exon. Its probes are marked as sent and leave this list and the CSV until their design is imported or you return them to the sheet.', trigger: React.createElement(Button, { icon: 'paper plane', content: 'Mark sheet as sent to Exon', loading: this.state.markingDispatched, disabled: this.state.markingDispatched, onClick: function () { var _a; return (_a = _this.dispatchFileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }) }),
                React.createElement("a", { href: API_SVC_BASE_URL + "/probe-design/bulk-probe-design-csv", target: '_blank', rel: 'noopener noreferrer' },
                    React.createElement(Button, { icon: 'download', content: "Download CSV (" + this.state.rows.length + " kit" + (this.state.rows.length === 1 ? '' : 's') + ")", positive: true }))));
    };
    ProbeDesignReviewModal.prototype.renderTable = function () {
        var _this = this;
        // The rows an admin can act on float to the top; the rest keep the sheet's order
        var rows = __spreadArrays(this.state.rows).sort(function (a, b) {
            return Number(b.assignableCat != null && b.comment.trim() !== '') -
                Number(a.assignableCat != null && a.comment.trim() !== '');
        });
        return React.createElement(Table, { compact: true, celled: true },
            React.createElement(Table.Header, null,
                React.createElement(Table.Row, null,
                    React.createElement(Table.HeaderCell, null, "Order"),
                    React.createElement(Table.HeaderCell, null, "Customer"),
                    React.createElement(Table.HeaderCell, null, "Kit"),
                    React.createElement(Table.HeaderCell, null, "Ch"),
                    React.createElement(Table.HeaderCell, null, "Target"),
                    React.createElement(Table.HeaderCell, null, "Organism"),
                    React.createElement(Table.HeaderCell, null, "Comment"),
                    React.createElement(Table.HeaderCell, null, "Status"),
                    React.createElement(Table.HeaderCell, null))),
            React.createElement(Table.Body, null, rows.map(function (row) { return _this.renderRow(row); })));
    };
    ProbeDesignReviewModal.prototype.renderRow = function (row) {
        var _this = this;
        var key = rowKey(row);
        var hasComment = row.comment.trim() !== '';
        var siteless = row.sitelessDesign;
        var uploadingSites = this.state.sitesUploadRow === key;
        return React.createElement(Table.Row, { key: key, warning: row.assignableCat != null && hasComment, style: siteless ? { backgroundColor: '#f7f2fb' } : undefined },
            React.createElement(Table.Cell, null, row.orderNumber),
            React.createElement(Table.Cell, null, row.customerName),
            React.createElement(Table.Cell, { textAlign: 'center' }, row.kitNumber),
            React.createElement(Table.Cell, { textAlign: 'center' }, row.channel),
            React.createElement(Table.Cell, null,
                row.targetName,
                React.createElement("span", { style: { color: 'rgba(0,0,0,0.4)' } },
                    " \u00B7 ",
                    row.sequenceLength,
                    " nt \u00B7 ",
                    row.platform)),
            React.createElement(Table.Cell, null, row.organismName),
            React.createElement(Table.Cell, null,
                hasComment
                    ? row.comment
                    : React.createElement("span", { style: { color: 'rgba(0,0,0,0.4)' } }, "\u2014"),
                row.designComment !== '' &&
                    React.createElement("div", { style: { color: 'rgba(0,0,0,0.5)', fontStyle: 'italic' } },
                        "Design note: ",
                        row.designComment)),
            React.createElement(Table.Cell, null,
                this.renderStatus(row, hasComment),
                siteless &&
                    React.createElement("div", { style: { marginTop: '0.3em' } },
                        React.createElement(Label, { color: 'purple', basic: true },
                            "Assigned ",
                            siteless.designNumber,
                            " \u00B7 no binding sites on record"))),
            React.createElement(Table.Cell, { textAlign: 'center' },
                siteless &&
                    React.createElement(Popup, { content: "This kit already holds " + siteless.variantName + " (" + siteless.designNumber + ") but we have no " +
                            'binding sites for it, so it looks undesigned. Upload the designer\'s Compare .xlsx for this ' +
                            'variant to backfill the sites — the kit then leaves this sheet and becomes lot-eligible.', trigger: React.createElement(Button, { size: 'small', color: 'purple', basic: true, loading: uploadingSites, disabled: uploadingSites, onClick: function () { return _this.pickBindingSitesFile(row); } }, "Add binding sites") }),
                row.assignableCat &&
                    React.createElement(Popup, { content: 'Assign the existing catalog design ' +
                            (row.assignableCat.designNumber + " (" + row.assignableCat.bindingSites + " binding sites) ") +
                            'to this kit. It skips Exon and leaves this sheet.' +
                            (hasComment ? ' Only do this if the comment is not a design instruction.' : ''), trigger: React.createElement(Button, { size: 'small', positive: true, loading: this.state.assigning.has(key), disabled: this.state.assigning.has(key), onClick: function () { return _this.assign(row); } },
                            "Assign CAT (",
                            row.assignableCat.bindingSites,
                            " sites)") })));
    };
    ProbeDesignReviewModal.prototype.renderSentSection = function () {
        var _this = this;
        return React.createElement(React.Fragment, null,
            React.createElement(Header, { size: 'small' },
                "Sent to Exon",
                React.createElement(Header.Subheader, null, "These probes are in flight at Exon \u2014 they stay off the CSV until the design is imported, even if the kit is edited in the meantime. Return one to the sheet if it was marked by mistake or needs a new design.")),
            React.createElement(Table, { compact: true, celled: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null, "Order"),
                        React.createElement(Table.HeaderCell, null, "Customer"),
                        React.createElement(Table.HeaderCell, null, "Kit"),
                        React.createElement(Table.HeaderCell, null, "Ch"),
                        React.createElement(Table.HeaderCell, null, "Target"),
                        React.createElement(Table.HeaderCell, null, "Organism"),
                        React.createElement(Table.HeaderCell, null, "Sent"),
                        React.createElement(Table.HeaderCell, null))),
                React.createElement(Table.Body, null, this.state.sentRows.map(function (row) {
                    var key = "sent-" + row.orderNumber + "-" + row.kitNumber + "-" + row.channel;
                    return React.createElement(Table.Row, { key: key },
                        React.createElement(Table.Cell, null, row.orderNumber),
                        React.createElement(Table.Cell, null, row.customerName),
                        React.createElement(Table.Cell, { textAlign: 'center' }, row.kitNumber),
                        React.createElement(Table.Cell, { textAlign: 'center' }, row.channel),
                        React.createElement(Table.Cell, null,
                            row.targetName,
                            React.createElement("span", { style: { color: 'rgba(0,0,0,0.4)' } },
                                " \u00B7 ",
                                row.platform)),
                        React.createElement(Table.Cell, null, row.organismName),
                        React.createElement(Table.Cell, null, row.sentAt.slice(0, 10)),
                        React.createElement(Table.Cell, { textAlign: 'center' },
                            React.createElement(Button, { size: 'small', basic: true, loading: _this.state.assigning.has(key), disabled: _this.state.assigning.has(key), onClick: function () { return _this.returnToSheet(row, key); } }, "Return to sheet")));
                }))));
    };
    ProbeDesignReviewModal.prototype.renderFyiSection = function () {
        var _this = this;
        return React.createElement(React.Fragment, null,
            React.createElement(Header, { size: 'small' },
                "Designed kits with comments",
                React.createElement(Header.Subheader, null, "These kits already carry a design (usually a reorder) and the customer added a comment. Nothing to do if the comment is just logistics. If it is a design instruction, remove the design \u2014 the kit then joins the design sheet for a new one.")),
            React.createElement(Table, { compact: true, celled: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null, "Order"),
                        React.createElement(Table.HeaderCell, null, "Customer"),
                        React.createElement(Table.HeaderCell, null, "Kit"),
                        React.createElement(Table.HeaderCell, null, "Ch"),
                        React.createElement(Table.HeaderCell, null, "Target"),
                        React.createElement(Table.HeaderCell, null, "Organism"),
                        React.createElement(Table.HeaderCell, null, "Comment"),
                        React.createElement(Table.HeaderCell, null, "Design"),
                        React.createElement(Table.HeaderCell, null))),
                React.createElement(Table.Body, null, this.state.fyiRows.map(function (row) { return _this.renderFyiRow(row); }))));
    };
    ProbeDesignReviewModal.prototype.renderFyiRow = function (row) {
        var _this = this;
        var key = "fyi-" + row.orderNumber + "-" + row.kitNumber + "-" + row.channel;
        return React.createElement(Table.Row, { key: key },
            React.createElement(Table.Cell, null, row.orderNumber),
            React.createElement(Table.Cell, null, row.customerName),
            React.createElement(Table.Cell, { textAlign: 'center' }, row.kitNumber),
            React.createElement(Table.Cell, { textAlign: 'center' }, row.channel),
            React.createElement(Table.Cell, null,
                row.targetName,
                React.createElement("span", { style: { color: 'rgba(0,0,0,0.4)' } },
                    " \u00B7 ",
                    row.platform)),
            React.createElement(Table.Cell, null, row.organismName),
            React.createElement(Table.Cell, null,
                row.comment,
                row.designComment !== '' &&
                    React.createElement("div", { style: { color: 'rgba(0,0,0,0.5)', fontStyle: 'italic' } },
                        "Design note: ",
                        row.designComment)),
            React.createElement(Table.Cell, null,
                React.createElement(Label, { basic: true, color: 'blue' },
                    row.variantName,
                    " \u00B7 ",
                    row.designNumber,
                    " \u00B7 ",
                    row.bindingSites,
                    " sites")),
            React.createElement(Table.Cell, { textAlign: 'center' },
                React.createElement(Popup, { content: 'Detach this design because the comment IS a design instruction. The kit reverts to ' +
                        'the customer\'s original target inputs and joins the design sheet for Exon.', trigger: React.createElement(Button, { size: 'small', negative: true, basic: true, loading: this.state.assigning.has(key), disabled: this.state.assigning.has(key), onClick: function () { return _this.removeDesign(row, key); } }, "Remove design") })));
    };
    ProbeDesignReviewModal.prototype.renderStatus = function (row, hasComment) {
        if (row.catalogDesignFlagged) {
            // No comment + catalog match: the sheet flags it and the import makes/reuses CAT.
            // mi-brand-label restyles this to $brand-green in mi-ui; semantic green elsewhere.
            return React.createElement(Label, { className: 'mi-brand-label', color: 'green' }, "CAT on import");
        }
        if (row.catalogMatch && hasComment) {
            // The one case needing human judgment: catalog target, but a comment blocks the flag
            return React.createElement(Label, { color: 'orange', basic: true }, "Catalog match \u2014 comment blocks auto-flag");
        }
        return React.createElement(Label, { basic: true }, "Custom design");
    };
    return ProbeDesignReviewModal;
}(React.PureComponent));
export default ProbeDesignReviewModal;
var rowKey = function (row) { return row.orderNumber + "-" + row.kitNumber + "-" + row.channel; };
//# sourceMappingURL=ProbeDesignReviewModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ProbeDesignReviewModal.js
// module id = 1239
// module chunks = 0